import { ChangeModel } from './change.model';

export const createChange = (
  type: ChangeModel['type'],
  data: Partial<ChangeModel>
): ChangeModel => {
  return {
    type,
    ...data,
  } as ChangeModel;
};
